import { PartnerContactsConfig } from 'clickNgo/widgets/partnerContacts'
import { ContactTypeSelectorSegment } from 'clickNgo/widgets/partnerContacts/configs'
import { partnerContactsTranslation } from 'clickNgo/widgets/partnerContacts/translation'

export const ONBOARDING_CONTACTS_CONFIG: Required<PartnerContactsConfig> = {
  isOnboarding: true,
  isPartnerSelectorVisible: false,
  isDraftContactCreationEnabled: true,
  defaultSegment: ContactTypeSelectorSegment.SelectedPartner,
  segments: [
    {
      key: ContactTypeSelectorSegment.SelectedPartner,
      text: partnerContactsTranslation.contacts.controls.segment.partner,
    },
    {
      key: ContactTypeSelectorSegment.AllContacts,
      text: partnerContactsTranslation.contacts.controls.segment.all,
    },
    {
      key: ContactTypeSelectorSegment.ProfilingRequests,
      text: partnerContactsTranslation.contacts.controls.segment.profiling,
    },
    {
      key: ContactTypeSelectorSegment.NewContacts,
      text: partnerContactsTranslation.contacts.controls.segment.new,
    },
  ],
}
